import { css, unsafeCSS } from 'lit-element';
import {
  n400, n50, info300, info50, negative300, negative50, positive300, positive50, warning300, warning50,
} from '@aab/sc-styles-colors';
import {
  sml_2 as sml2, px_0 as px0, spl_1 as spl1, spx_1 as spx1,
} from '@aab/sc-styles-spacing';
import { text_small as textSmall } from '@aab/sc-styles-typography';
import { d_flex as dFlex } from '@aab/sc-styles-utilities';

const messageStyles = css`
  ${unsafeCSS(sml2)}
  ${unsafeCSS(px0)}
  ${unsafeCSS(spl1)}
  ${unsafeCSS(spx1)}
  ${unsafeCSS(textSmall)}
  ${unsafeCSS(dFlex)}


  [hidden] {
    display: none !important;
  }
  
  .background.inactive {
    background-color: ${unsafeCSS(n50)};
  }
  .background.info {
    background-color: ${unsafeCSS(info50)};
  }
  .background.negative {
    background-color: ${unsafeCSS(negative50)};
  }
  .background.positive {
    background-color: ${unsafeCSS(positive50)};
  }
  .background.warning {
    background-color: ${unsafeCSS(warning50)};
  }
  
  .message-text.inactive {
    color: ${unsafeCSS(n400)};
  }
  .message-text.info {
    color: ${unsafeCSS(info300)};
  }
  .message-text.negative {
    color: ${unsafeCSS(negative300)};
  }
  .message-text.positive {
    color: ${unsafeCSS(positive300)};
  }
  .message-text.warning {
    color: ${unsafeCSS(warning300)};
  }
  .inline-icon {
    padding-top: 2px;
  }
  
  .text-nowrap {
    white-space: nowrap!important;
  }
`;

export const demoStyles = css`
  .aab-inputmessage-demo-container {
    font-family: "Roboto","Helvetica Neue",Arial,sans-serif;
    font-size: 1rem;
    font-weight: 400;
    color: #222;
    text-align: left;
  }
`;

export default messageStyles;
